import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    // Three linked profile dots. The inline fill:none is required, not
    // redundant: `foreground` makes Gutenberg add `.has-colors`, whose
    // `fill: currentcolor` rule beats the fill presentation attribute and
    // would render the icon as a solid blob. Same fix as Share Post.
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="5.5" cy="12" r="2.75" />
        <circle cx="12" cy="12" r="2.75" />
        <circle cx="18.5" cy="12" r="2.75" />
      </svg>
    ),
  },
});
